const encoder = new TextEncoder()
const decoder = new TextDecoder()

export type ResortCursor = {
  name: string
  uid: string
}

export const DEFAULT_PAGE_SIZE = 25
export const MAX_PAGE_SIZE = 100

export const encodeCursor = (cursor: ResortCursor): string => {
  const payload = JSON.stringify(cursor)
  const bytes = encoder.encode(payload)
  let binary = ""

  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i])
  }

  return btoa(binary).replace(/=+$/, "").replace(/\+/g, "-").replace(/\//g, "_")
}

const padBase64 = (value: string) => {
  const paddingNeeded = (4 - (value.length % 4)) % 4
  return value + "=".repeat(paddingNeeded)
}

export const decodeCursor = (value: string): ResortCursor => {
  const base64 = padBase64(value).replace(/-/g, "+").replace(/_/g, "/")
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)

  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i)
  }

  return JSON.parse(decoder.decode(bytes))
}

export type PaginationOptions = {
  cursor?: string
  limit?: number
  filter?: string
  sort?: string
  dir?: "asc" | "desc"
}

export const buildPaginationParams = ({
  cursor,
  limit = DEFAULT_PAGE_SIZE,
  filter,
  sort,
  dir,
}: PaginationOptions) => {
  const safeLimit = Math.min(Math.max(limit, 1), MAX_PAGE_SIZE)
  const params = new URLSearchParams({ limit: `${safeLimit}` })
  if (cursor) {
    params.set("cursor", cursor)
  }
  if (filter) {
    params.set("filter", filter)
  }
  if (sort) {
    params.set("sort", sort)
  }
  if (dir) {
    params.set("dir", dir)
  }
  return params.toString()
}
